import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import HomePage from "./HomePage";
import ContactPage from "./components/ContactPage";
import AboutPage from "./components/AboutPage";
import MyAccountPage from "./components/MyAccountPage";
import CreateExam from "./components/exam/CreateExam"
import ExamQuestionPage from "./components/exam/ExamQuestionPage";
import IAATExamples from "./components/iaat/IAATExamples";
import IAAT from "./components/iaat/IAAT";
import Cogat from "./components/cogat/Cogat";
import Nnat from "./components/nnat/Nnat";
import { pageview } from "./utils/gtag";

// Component to track page views on route changes
function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    pageview(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <PageViewTracker />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/account" element={<MyAccountPage />} />
        <Route path="/contact" element={<ContactPage />} /> 
        <Route path="/about" element={<AboutPage />} /> 
        <Route path="/createexam" element={<CreateExam />} /> 
        <Route path="/exam/:exam_id" element={<ExamQuestionPage />} />
        <Route path="IAATExample" element={<IAATExamples />}/>
        <Route path="iaat" element={<IAAT />}/>
        <Route path="cogat" element={<Cogat />}/>
        <Route path="nnat" element={<Nnat />}/>
      </Routes>
    </Router> 
  );
}

export default App;
